import validate from "/opt/vims-fe-live/node_modules/nuxt/dist/pages/runtime/validate.js";
import acl_45global from "/opt/vims-fe-live/middleware/acl.global.js";
import permission_45global from "/opt/vims-fe-live/middleware/permission.global.js";
import manifest_45route_45rule from "/opt/vims-fe-live/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  acl_45global,
  permission_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  auth: () => import("/opt/vims-fe-live/node_modules/@sidebase/nuxt-auth/dist/runtime/middleware/auth.mjs")
}